import React from 'react';
import SectionHeader from './ui/SectionHeader';
import { FiPlus, FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function BundleBuilder() {
  return (
    <section className="py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-[3rem] p-12 md:p-20 shadow-xl border border-stone-100 flex flex-col lg:flex-row gap-16 items-center">
          <div className="lg:w-1/2">
            <SectionHeader title="Build Your Custom Bundle" subtitle="Gifting & Kits" centered={false} />
            <p className="text-stone-500 text-lg mb-10 leading-relaxed">
              Save 15% when you curate your own hydration kit. Choose your vessel, select your lid, and add your accessories. Perfect for corporate gifting or gear upgrades.
            </p>
            
            <div className="space-y-6 mb-12">
              <div className="flex items-center gap-4 p-4 border border-stone-100 rounded-2xl bg-stone-50">
                <div className="w-10 h-10 bg-teal-700 text-white rounded-full flex items-center justify-center font-bold">1</div>
                <span className="font-bold text-stone-900">Select Your Vessel (Flask or Cup)</span>
              </div>
              <div className="flex items-center gap-4 p-4 border border-teal-100 rounded-2xl bg-teal-50/50">
                <div className="w-10 h-10 bg-teal-700 text-white rounded-full flex items-center justify-center font-bold">2</div>
                <span className="font-bold text-stone-900">Choose Cap & Bumper Colors</span>
              </div>
              <div className="flex items-center gap-4 p-4 border border-stone-100 rounded-2xl bg-stone-50">
                <div className="w-10 h-10 bg-teal-700 text-white rounded-full flex items-center justify-center font-bold">3</div>
                <span className="font-bold text-stone-900">Add Cleaning Essentials</span>
              </div>
            </div>

            <button className="flex items-center gap-3 bg-stone-900 text-white px-10 py-5 rounded-full font-bold hover:bg-stone-800 transition-all shadow-lg shadow-stone-900/20 group">
              Start Building <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>

          <div className="lg:w-1/2 relative grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <img src="https://images.unsplash.com/photo-1602143407151-7111542de6e8?q=80&w=400&auto=format&fit=crop" className="rounded-2xl shadow-md" alt="Bundle part" />
              <img src="https://images.unsplash.com/photo-1585241936939-f5ded727c95d?q=80&w=400&auto=format&fit=crop" className="rounded-2xl shadow-md" alt="Bundle part" />
            </div>
            <div className="space-y-4 pt-12">
              <img src="https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?q=80&w=400&auto=format&fit=crop" className="rounded-2xl shadow-md" alt="Bundle part" />
              <div className="aspect-square bg-teal-700 rounded-2xl flex flex-col items-center justify-center text-white p-6 text-center shadow-md">
                <span className="text-3xl font-black mb-2">15% OFF</span>
                <span className="text-sm font-bold uppercase tracking-widest">Bundle Discount</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}